import React from 'react';
import PropTypes from 'prop-types';
import { flattenToAppURL } from '@plone/volto/helpers';
import { Grid, Container } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { UniversalLink, PreviewImage } from '@plone/volto/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { keys, isEmpty, map, filter } from 'lodash';
import { ClusterMap } from '../../';


const EquipmentsListing = ({ items, linkTitle, linkHref, isEditMode, blockTitle }) => {

	let href = (linkHref?.[0]?.['@id']) || '';
	let link = href ? flattenToAppURL(href) : '';

	const itemsGeolocation = items.filter(item => item.geolocation);

	return (
		<div className={'equipmentsMapListing d-print-none' + (isEditMode ? ' position-relative' : ' ')}>
			{blockTitle && (<h2 className="equipmentsMapListing__title mt-0 h1">{blockTitle}</h2>)}

			<ClusterMap markers={itemsGeolocation} />

			{link &&
				<p className="readMoreItem d-print-none">
					<UniversalLink href={link} className="readMoreItem__btn ui button primary">
						{linkTitle ? (<span>{linkTitle}</span>) :
							(<FormattedMessage id="See all" defaultMessage="See all" />)}
						{blockTitle}
						<FontAwesomeIcon icon={faChevronRight} className="readMoreItem__icon ms-3" />
					</UniversalLink>
				</p>
			}
		</div>
	);
}

EquipmentsListing.propTypes = {
	linkHref: PropTypes.arrayOf(PropTypes.any),
	items: PropTypes.arrayOf(PropTypes.any).isRequired,
	linkMore: PropTypes.any,
	isEditMode: PropTypes.bool,
};

export default EquipmentsListing;
